<template>
    <div class="container-fluid text-center">
        <h1 class="mt-5 mb-3 h1">Contact</h1>
        <p>Need to get in touch? It's easy, just <a href="javascript:location='mailto:\u0068\u0065\u006c\u006c\u006f\u0040\u0064\u0072\u0065\u006e\u0063\u0068\u0061\u0070\u0070\u002e\u0063\u006f\u006d';void 0">send an email</a>.</p>
        
        <p class="mt-5 mb-5"><better-link class="btn btn-sm btn-outline-secondary text-dark" to="/">Back to the Homepage</better-link></p>
    </div>
</template>

<script>
export default {
    name: 'Contact',
    head: {
        title() {
            return {
                inner: 'Contact',
            }
        },
    },
    activated() {
        this.$emit('updateHead')
    },
};
</script>